import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  oldPassword: Yup.string().required('O campo senha é obrigatório'),
  password: Yup.string()
    .required('O campo senha é obrigatório')
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\p{L}\d]).{8,30}$/u,
      'A senha deve ter de 8 a 30 caracteres, com pelo menos uma letra minúscula, uma maiúscula, um número e um símbolo')
    // A nova senha não pode ser igual à senha atual
    .notOneOf([Yup.ref('oldPassword')], 'A nova senha não pode ser igual à senha atual'),
  passwordConfirmation: Yup.string()
    .required('O campo confirmação de senha é obrigatório')
    .oneOf([Yup.ref('password'), null], 'As senhas não conferem'),
});

export default validationSchema;
